import styles from "./styles/vocal-remover-advantage-info.module.scss";
import Image from "next/image";

interface VocalRemoverAdvantageInfoProps {
  image: string;
  title: string;
  description: string;
}

const VocalRemoverAdvantageInfo = ({
  image,
  title,
  description,
}: VocalRemoverAdvantageInfoProps) => {
  return (
    <div className={styles.wrapper}>
      <Image src={image} alt={""} width={60} height={60} />
      <div className={styles.info}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
};

export default VocalRemoverAdvantageInfo;
